module.exports = __webpack_public_path__ + "src/img/defaultAudio.d172f3f5.png";